import { Stack, Typography } from '@common-components';
import { PlacementType, RemarketEligibilityStatus } from 'enums';
import { getRemarketingEligibilityConfig } from 'broker/configuration-mappers/submission-remarketing-eligibility-config';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export default function RemarketingEligibility() {
  const { submission } = useSubmissionsWorkspace();

  if (submission?.placementType !== PlacementType.Direct) {
    return undefined;
  }

  const { text, color } = getRemarketingEligibilityConfig(submission.remarketEligibility?.status);

  return (
    <Stack
      gap={0.5}
      bgcolor={color}
      py={2}
      px={1.5}
      mx={2}
      borderRadius={1}
      my={1}
      textAlign="center"
      justifyContent="center"
      direction="row"
    >
      <Typography variant="body1Bold">{text}</Typography>
      {submission.remarketEligibility.status === RemarketEligibilityStatus.Eligible && (
        <Typography variant="body1">{`- ${submission.remarketEligibility.reason}`}</Typography>
      )}
    </Stack>
  );
}
